module.exports = __webpack_public_path__ + "static/media/sponsorVision.cc7e3fc4.jpg";